<template>

  <div>
    <div class="max-w-2xl mx-auto py-2 px-2">
      <div class="md:grid">
        <div>
          <div class="py-4">
            <span>Novo Grupo</span>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <form @submit.prevent="save">
              <div class="shadow overflow-hidden sm:rounded-md">
                <div class="px-4 py-5 bg-white">
                  <div class="grid grid-cols-1 py-2">
                    <div class="col-span-12 sm:col-span-2">
                      <label class="block font-medium text-sm text-gray-700">
                        Nome
                      </label>
                      <el-input
                        class="mt-1 w-full "
                        v-model="form.name"
                      >
                      </el-input>
                      <jet-input-error
                        :message="form.errors.name"
                        class="mt-2"
                      />
                    </div>
                  </div>
                </div>
                <div class="flex items-center justify-end px-4  bg-gray-50 text-right sm:px-6">
                  <jet-action-message
                    :on="form.recentlySuccessful"
                    class="mr-3"
                  >
                    Salvo.
                  </jet-action-message>
                </div>
                <div class="flex flex-row-reverse space-x-4 space-x-reverse px-4 py-2 sm:py-6 bg-gray-50">
                  <button-primary
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                  > Salvar
                  </button-primary>
                  <button-secondary>
                    Cancelar
                  </button-secondary>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label';
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';



export default {
  name: 'RoleCreate',
  components: {
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
    ButtonPrimary,
    ButtonSecondary
  },
  data() {
    return {
      form: this.$inertia.form({
        name: ''
      })
    }
  },
  methods: {
    save() {
      this.form.post(route('accesscontrol.role.store'), {
        preserveScroll: true
      });
    }
  }
}
</script>


<style scoped>
</style>
